import { Provider } from '@angular/core';
import { MissingTranslationHandler, TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomMissingTranslationHandler } from './services/custom-missing-translation-handler';

/**
 * v17 of @ngx-translate/http-loader uses inject() internally, so the loader
 * must be registered via useClass (DI context) instead of useFactory (no DI context).
 * TRANSLATE_HTTP_LOADER_CONFIG must be provided separately in the root injector.
 */
export const TRANSLATE_HTTP_LOADER_CONFIG_PROVIDER: Provider = {
  provide: TRANSLATE_HTTP_LOADER_CONFIG,
  useValue: { prefix: '/app/assets/i18n/', suffix: '.json' },
};

export const TRANSLATE_LOADER_PROVIDER: Provider = {
  provide: TranslateLoader,
  useClass: TranslateHttpLoader,
};

export const MISSING_TRANSLATION_HANDLER_PROVIDER: Provider = {
  provide: MissingTranslationHandler,
  useClass: CustomMissingTranslationHandler,
};

export const TRANSLATE_MODULE_CONFIG: TranslateModuleConfig = {
  loader: TRANSLATE_LOADER_PROVIDER,
  missingTranslationHandler: MISSING_TRANSLATION_HANDLER_PROVIDER,
};
